export type NextEvent = { type: 'NEXT' };
export const next = (): NextEvent => ({ type: 'NEXT' });

export type BackEvent = { type: 'BACK' };
export const back = (): BackEvent => ({ type: 'BACK' });
